// Third-party
import React from 'react';
import { ProgressBar } from 'react-bootstrap';

// Utils
import { formatMessage } from '@/utils/i18n';

// Images
import { ReactComponent as CsvIcon } from '@/images/csv-icon.svg?react';

type Props = {
  progress: number;
  file?: File;
};

const ProcessingStep: React.FC<Props> = ({ progress, file }) => (
  <div className="file-uploader-processing-step">
    <div className="file-uploader-progress-wrapper">
      <div className="file-uploader-progress">
        <CsvIcon className="file-uploader-csv-icon" />
        <div className="mt-3">
          <span className="me-2">{formatMessage('Modal.PortfolioUpload.UploadingVerifying')}</span>
        </div>

        <div className="file-uploader-progress-file-name">{file?.name}</div>
        <ProgressBar className="file-uploader-progress-bar" now={progress} />
      </div>
    </div>
  </div>
);

export default ProcessingStep;
